import uniq from 'lodash/uniq';

export interface DxCodeForDisplay {
  description: string;
  code: string;
  value: string;
  key: string;
  displayText: string;
  dsm?: string;
  primaryGroup: string;
  secondaryGroup: string;
  searchable?: string;
  subText: string;
}

export interface DxCode {
  description: string;
  code: string;
  dsm?: string;
  primaryGroup: string;
  secondaryGroup: string;
}

export const createSearchableData = (diagnosisCodes: DxCode[]) => {
  return diagnosisCodes.map((dxCode) => {
    const { description, code, dsm, primaryGroup, secondaryGroup } = dxCode;

    return {
      ...dxCode,
      key: code,
      value: code,
      displayText: `${code}${dsm ? ` | DSM ${dsm}` : ''} • ${description}`,
      subText: `\n${primaryGroup} | ${secondaryGroup}`,
      searchable: uniq([
        '•',
        description,
        code,
        dsm,
        primaryGroup,
        secondaryGroup,
        `${!!dsm ? 'DSM |' : ''}`,
      ])
        .filter((x) => x)
        .join(' ')
        .toLowerCase()
        .trim(),
    } as DxCodeForDisplay;
  });
};

export const filterCodes = (data: DxCodeForDisplay[], term: string, excludeCodes: string[]) => {
  const terms = term
    .toLowerCase()
    .split(' ')
    .filter((x) => x);

  return data.filter((dxCode) => {
    return (
      [...excludeCodes].indexOf(dxCode.code) === -1 &&
      terms.every((word) => dxCode.searchable?.includes(word))
    );
  });
};
